import { IMoveToProjectParams } from '../types/IMoveToProjectParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class MoveMetricsToProject extends Request<IMoveToProjectParams, IResult> {
  constructor(params: IMoveToProjectParams) {
    super('moveMetricsToProject', params);
  }
}
